// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"7a0c6fcef933df78fc7f","303":"6ba87e532595ccfd1430","495":"106c4d4653e2116e5bfc"}[chunkId] + ".js";
};